import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Spin,
  Select, 
  Divider, 
  Avatar,
  InputNumber,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { save, saveFile } from "../../../features/save/saveSlice"; 
import BreadCrumb from "../../../layout/BreadCrumb";
import { fetchCounties, fetchCrops, fetchDepts, fetchProfiles, fetchUsrStatus } from "../../../features/fetch/fetchSlice";
import { formatImgPath } from "../../../utils";
import { EditOutlined } from "@ant-design/icons";


const UserAdd = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { department, usrStatuses, profiles } = useSelector((state) => state.fetch); 
    const { activeObjUser } = useSelector((state) => ({
      activeObjUser: state.obj.activeObj["usersData"],
    }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/user/users-list");
  }

  const [imageSrc, setImageSrc] = useState(
    formatImgPath(activeObjUser?.usrLogo == null ? "avatar.png" : activeObjUser?.usrLogo)
  );

  

  const [accProfile, setAccProfile] = useState(activeObjUser?.usrLogo  ?? null);

  const handleImageChange = async (e) => {
    let file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    const res = await dispatch(saveFile(formData));
    if (res?.payload?.success) { 
      const formatted = formatImgPath(res.payload?.targetUrl); 
      await setImageSrc(formatted); 
      await setAccProfile(res.payload?.targetUrl); 
      await toast.success(res?.payload?.message);
    } else {
      toast.error(res?.payload?.message);
    }
  };

 
 
  const onFinish = async (data) => {
    data.usrId = activeObjUser?.usrId ? activeObjUser?.usrId : ""; 
    data.usrLogo = accProfile
    const res = await dispatch(
      save({
        ...data,
        url: "usr/user",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjUser,
    });
  }, [activeObjUser, form]);

  const initialFormValues = {
    ...activeObjUser,
  };
 

  useEffect(() => {
    dispatch(fetchDepts());
    dispatch(fetchUsrStatus());
    dispatch(fetchProfiles());
  }, []);

  useEffect(() => {
    setImageSrc(
      formatImgPath(
        activeObjUser?.usrLogo == null ? "avatar.png" : activeObjUser?.usrLogo
      )
    );
    setAccProfile(activeObjUser?.usrLogo  ?? null)
  }, [activeObjUser]);
 
 
  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Users", path: "/user/users-list" },
          { title: "User Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">Register a new user</div>
        <Divider />
        <div className="w-full mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            <div className="relative">
              <button className="mb-10">
                <Avatar size={150} src={imageSrc} />
                <div className="absolute left-[10%] bottom-10">
                  <EditOutlined />
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                />
              </button>
            </div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-[3.75rem]">
              <Form.Item
                name="usrFirstName"
                label={"First Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add first name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="usrLastName"
                label={"Second Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add second name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="email"
                label={"Email"}
                rules={[
                  {
                    required: true,
                    message: "Please add email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>
              <Form.Item
                name="usrNationalId"
                label="ID Number"
                rules={[
                  {
                    required: true,
                    message: "National ID is required",
                  },
                  {
                    validator(_, value) {
                      if (value && value.toString().length < 6) {
                        return Promise.reject(
                          "National ID must be at least 6 characters long"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                 
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="phoneNumber"
                label={"Mobile Number"}
                rules={[
                  {
                    required: true,
                    message: "Please add mobile number",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>

              <Form.Item
                name="usrDeptId"
                className=""
                label={"Department"}
                rules={[
                  {
                    required: true,
                    message: "Please select department",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    department?.length > 0 &&
                    department?.map((item) => ({
                      value: item?.depId,
                      label: item?.depDepartment,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="usrProId"
                className=""
                label={"Profile"}
                rules={[
                  {
                    required: true,
                    message: "Please select profile",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    profiles?.length > 0 &&
                    profiles?.map((item) => ({
                      value: item?.profId,
                      label: item?.profProfile,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="usrUserStatus"
                className=""
                label={"Status"}
                rules={[
                  {
                    required: true,
                    message: "Please select status",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    usrStatuses?.length > 0 &&
                    usrStatuses?.map((item) => ({
                      value: item?.usrsStatus,
                      label: item?.usrsStatus,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button disabled={saving} key="submit" type="submit" className="cstm-btn-2">
                    {saving ? (
                      <Spin />
                    ) : activeObjUser?.usrId ? (
                      "Update"
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default UserAdd;
